import { Root } from "@/models/roots/root.model";
import { createSlice } from "@reduxjs/toolkit";

const LadleHeatMetricInitialState: {
	ladles: Root[];
} = {
	ladles: [],
};

export const LadleHeatMetricReducer = createSlice({
	name: "__",
	initialState: LadleHeatMetricInitialState,
	reducers: {
		setLadles(state, { payload }) {
			state.ladles = payload;
		},
	},
});
